export default __webpack_public_path__ + "static/media/029-tank.10e76a3b.svg";